import axiosClient from "./axiosClient";

/**
 * Fetch user transaction history
 * @param {string} token 
 * @param {string|number} userId 
 */
export const getTransactions = async (token, userId) => {
  try {
    const res = await axiosClient.get(`/profile/transactions.php`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        user_id: userId,
      }
    });
console.log("DATA:", res.data);
    return res.data;
  } catch (error) {
    console.error("Transaction API Error:", error);
    return { status: "error", message: "Unable to fetch transactions." };
  }
};
